import React, { Fragment, useState, useRef } from "react";
import _ from "lodash";
import RegisterFields from "../RegisterFields";
import techFormFields from "./techFormFields";

export const TechForm = (props) => {
  const inputRef = useRef({});

  const renderFields = () => {
    return _.map(techFormFields, ({ label, name, type, options, required }) => {
      return (
        <RegisterFields
          name={name}
          label={label}
          type={type}
          value={inputRef.current.name}
          options={options}
          required={required}
          onChange={props.onChange(name)}
          onChecked={props.onChecked}
          checked={false}
        />
      );
    });
  };

  return <Fragment>{renderFields()}</Fragment>;
};
